import gql from "graphql-tag";
import fetch from "node-fetch";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//Get All Neighborhood hub
export const QUERY_getNeighborhub = gql`
  query getNeighborhub(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getNeighborhub(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      neighborhood_name
      video_url
      created_at
      updated_at
      links {
        link_name
        link_url
        created_at
        updated_at
      }
    }
  }
`;

//Get list by own query
async function getNeighborhubbyname(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getNeighborhub,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export { getNeighborhubbyname };
